import React, { useEffect, useRef } from "react";
import "./shopComp.css";
import { gsap } from "gsap";
import ShopIcon from "../../images/shop.svg";

export default function ShopComp(props) {
  return (
    <div className="ringsShop-main">
      <div className="ringsShop-container">
        <div className="ringsShop-element ringsShop-product-1">
          <a target="_blank" rel="noopener noreferrer" href={props.href_1}>
            <div className="rings-images">
              <img className="zoom" src={props.ring_1} alt=""></img>
              <img className="shop-icon" src={ShopIcon} alt=""></img>
            </div>
          </a>
        </div>
        <div className="ringsShop-element ringsShop-product-2">
          <a target="_blank" rel="noopener noreferrer" href={props.href_2}>
            <div className="rings-images">
              <img className="zoom" src={props.ring_2} alt=""></img>
              <img className="shop-icon" src={ShopIcon} alt=""></img>
            </div>
          </a>
        </div>
        <div className="ringsShop-element ringsShop-product-3">
          <a target="_blank" rel="noopener noreferrer" href={props.href_3}>
            <div className="rings-images">
              <img className="zoom" src={props.ring_3} alt=""></img>
              <img className="shop-icon" src={ShopIcon} alt=""></img>
            </div>
          </a>
        </div>
        <div className="ringsShop-element ringsShop-product-4">
          <a target="_blank" rel="noopener noreferrer" href={props.href_4}>
            <div className="rings-images">
              <img className="zoom" src={props.ring_4} alt=""></img>
              <img className="shop-icon" src={ShopIcon} alt=""></img>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
}
